import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import { fetchRolesList } from "../../services/axios/apiManager";
import RolesList from "./rolesList";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
const Roles = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [roles, setRoles] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Roles");
    if (perms) {
      setGranted(perms);
    }
  };
  const getData = async () => {
    const res = await fetchRolesList();
    if (res?.data?.success && res?.data?.data) {
      setRoles(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else handleErrors(res, navigate);
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Dashboard</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Roles
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <RolesList
          roles={roles}
          setRoles={setRoles}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default Roles;
